import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AuthFacade } from '@piqet-angular/data';
import {
  PIQET,
  purchaseThanksPageTitle,
  purchaseThanksStr,
  trialActivePageTitle,
} from '@piqet-angular/shared';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-purchase-thanks',
  templateUrl: './purchase-thanks.component.html',
  styleUrls: ['./purchase-thanks.component.scss'],
})
export class PurchaseThanksComponent implements OnInit, AfterViewInit, OnDestroy {
  email = sessionStorage.getItem('registerEmail');
  title = inject(Title);
  route = inject(ActivatedRoute);
  sharedService = inject(SharedService);
  hasSharedLink = false;
  isTrialRegistration = false;

  constructor(public authFacade: AuthFacade) {}

  ngOnInit(): void {
    const currentRoute = this.route.snapshot.routeConfig?.path;
    this.title.setTitle(
      currentRoute == purchaseThanksStr ? purchaseThanksPageTitle : trialActivePageTitle
    );
    this.sharedService.loadGTScript();
    this.hasSharedLink = this.route.snapshot.queryParams['fromShared'] === 'true';

    this.isTrialRegistration = currentRoute !== purchaseThanksStr;

    const payload = {
      id: this.route.snapshot.queryParams['id'],
      state: this.route.snapshot.queryParams['state'],
      verifyUserUrl: encodeURIComponent(
        environment.locationPath + `/#/activate-user?activationCode=`
      ),
    };

    if (currentRoute == purchaseThanksStr) {
      this.authFacade.payment(payload);
    }
  }

  ngAfterViewInit() {
    this.sharedService.removeSuccessEmailFromSession();
  }

  ngOnDestroy(): void {
    this.sharedService.removeGTScript();
    this.title.setTitle(PIQET);
    this.sharedService.removeSuccessEmailFromSession();
  }
}
